"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** statics */
var defaultVal = undefined;
var _default = exports.default = {
  name: 'FormInputNumber',
  props: {
    val: {
      type: [String, Number],
      default: undefined
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 默认输入正数
    min: {
      type: Number,
      default: 0
    },
    // 配合后端字段长度，默认长度为9个字符
    max: {
      type: Number,
      default: 999999999
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      inputVal: ''
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    // 小数位数
    pointSize: function pointSize() {
      return this.getPrecision(this.step) || 0;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal, oldVal) {
        if (newVal === oldVal) {
          return false;
        }
        if (newVal === '' || newVal === undefined || newVal === null) {
          this.inputVal = defaultVal;
        } else if (String(newVal).indexOf('%') >= 0) {
          // 兼容一下历史数据“xx.xx%”, 移除%
          newVal = String(newVal).replaceAll('%', '');
          this.inputVal = Number(newVal) || defaultVal;
        } else {
          this.inputVal = newVal;
        }
      }
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    // 获取小数位数
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    // 输入
    handleNumInput: function handleNumInput(value) {
      if (this.isDisabled) {
        return false;
      }
      // 替换掉除数字和小数点的其余字符及多个小数点的输入，过滤规则：仅能输入任意数字和至多一个小数点
      var val = value + '';
      // 转化为数字处理
      if (this.pointSize === 0) {
        // 没有小数
        val = val.replace(/[^\-?\d]/g, '');
      } else {
        // 有小数
        val = val.replace(/[^\-?\d.]/g, '');
        // 指定小数位数（清除多余小数）
        var regexp = new RegExp("^(\\-)*(\\d+)\\.(\\d{0,".concat(this.pointSize, "}).*$"));
        val = val.replace(regexp, '$1$2.$3');
      }
      // 负数支持
      var sign = this.min < 0 && /^-/.test(val) ? '-' : '';
      val = val.replace(/\-/g, '');
      // 首位是0后续不允许输入数字
      // 必须保证第一个为数字而不是.
      val = val.replace(/^\./g, '');
      // 保证.只出现一次，而不能出现两次以上
      val = val.split('.').length > 2 ? val.replace(/\.$/, '') : val;
      // 剔除小数点前多余的0
      if (val.length > 0) {
        if (val.indexOf('.') > 0) {
          var nums = val.split('.');
          // 兼容输入时候的.
          val = Number(nums[0]) + '.' + (nums[1] || '');
        } else {
          val = Number(val) + '';
        }
      }

      // console.log(1111, this.min, this.max, Number(val))
      // 目前最小值不处理，客户要求不阻止用户输入并且不能变更用户输入的值。
      // if (Number(val) < this.min) {
      //   return false
      // }
      // 不可输入比最大值还大的数据，与app同步
      if (Number(val) > this.max) {
        return false;
      }
      // console.log(3)
      // 组合
      val = sign + val;

      // console.log('input', val, value)
      this.$emit('input', val);
      this.$emit('update:val', val);
    },
    // change event
    handleNumChange: function handleNumChange(value) {
      // console.log(2222)
      var val = value + '';
      // 如果只输入了负号，直接替换为空数据
      var strVal = String(val);
      if (strVal.indexOf('-') >= 0 && strVal.length <= 1) {
        val = '';
      } else if (strVal.length > 0 && strVal.indexOf('.') === strVal.length - 1) {
        // 过滤最后一位输入为“.”
        val = strVal.replace(/\.$/g, '');
      }
      this.$emit('change', val);
      this.$emit('update:val', val);
    },
    // blur event
    handleNumBlur: function handleNumBlur(event) {
      this.$emit('blur', event);
    }
  }
};